import { Component } from 'react'
import { Navigate } from 'react-router-dom'
import * as routes from '../routes'
import { Login } from '../auth'
import authClient from '../auth/authClient'
import { Loading } from '../shared'

class AdminLogin extends Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true
    }
  }

  componentDidMount() {
    authClient.initialize(() => {
      const handler = () => { this.setState({ loading: false }) }
      authClient.tryLogin(routes.adminAuthUrl).then(handler).catch(handler)
    })
  }

  render() {
    if (this.state.loading) {
      return <Loading />
    } else {
      if (authClient.isLoggedIn()) {
        return <Navigate to={routes.adminSearchPath} />
      } else {
        const loginProps = {
          providers: ['google'],
          signInUrl: routes.adminAuthUrl,
          signUpPath: routes.adminRootPath, // there is no sign up path for admins
          afterLoginPath: routes.adminSearchPath
        }
        return <Login {...loginProps} {...this.props} />
      }
    }
  }
}

export default AdminLogin

